import '@elastic/eui/dist/eui_theme_light.css';
import '@elastic/charts/dist/theme_light.css';
import './global.css';

import { IntlProvider } from 'react-intl';
import { ProvideAuth } from './views/Login/Auth';

/**
 * @info
 * translation are hardcoded
 * without any automation for the moment
 */

import it from 'my-lib/src/intl/it.json';
import { DrawerProvider, ModalProvider } from 'providers';

import { Router } from 'Routes';
import { WhiteLabelProvider } from 'providers/white-label/WhiteLabelProvider';

function App(): JSX.Element {
  return (
    <div className="App">
      <IntlProvider messages={it} locale="it" defaultLocale="it">
        <WhiteLabelProvider>
          <ProvideAuth>
            <DrawerProvider>
              <ModalProvider>
                <Router />
              </ModalProvider>
            </DrawerProvider>
          </ProvideAuth>
        </WhiteLabelProvider>
      </IntlProvider>
    </div>
  );
}

export default App;
